import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';

const MonthPicker = ({
	select,
	selected,
	initialMonth,
	initialYear,
	currentMonth,
	currentYear,
	datePicker,
}) => {
	const months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];

	const selectedYear = parseInt(
		selected?.from ? selected.from.getFullYear() : initialYear
	);
	const selectedMonth = selected?.from
		? selected.from.getMonth()
		: initialMonth - 1;

	const [currentlyViewedYear, setCurrentlyViewedYear] = useState(
		parseInt(selected?.from ? selected.from.getFullYear() : selectedYear)
	);

	const [prevYearDisabled, setPrevYearDisabled] = useState(
		selectedYear <= currentYear
	);

	const handleMonthClick = (month) => {
		let newYear = currentlyViewedYear;

		if (month === 0 && selectedMonth === 11) {
			newYear += 1;
		} else if (month === 11 && selectedMonth === 0) {
			newYear -= 1;
		}

		const from = new Date(newYear, month, 1);
		const to = new Date(newYear, month + 1, 0);

		select({ from, to });
	};

	const handlePrevYear = () => {
		setCurrentlyViewedYear((previouslyViewedYear) => {
			const prevYear = parseInt(previouslyViewedYear) - 1;

			if (prevYear <= currentYear) {
				setPrevYearDisabled(true);
			}

			return prevYear;
		});
	};

	const handleNextYear = () => {
		setCurrentlyViewedYear((previouslyViewedYear) => {
			setPrevYearDisabled(false);

			return parseInt(previouslyViewedYear) + 1;
		});
	};

	useEffect(() => {
		const previousMonthHandler = (e) => {
			if (!e?.detail?.datePicker || e.detail.datePicker !== datePicker) {
				return;
			}

			const prevMonth = (selectedMonth - 1 + 12) % 12;
			const prevYear =
				selectedMonth === 0
					? currentlyViewedYear - 1
					: currentlyViewedYear;
			setCurrentlyViewedYear(parseInt(prevYear));
			handleMonthClick(prevMonth);
		};

		const nextMonthHandler = (e) => {
			if (!e?.detail?.datePicker || e.detail.datePicker !== datePicker) {
				return;
			}

			const nextMonth = (selectedMonth + 1) % 12;
			const nextYear =
				selectedMonth === 11
					? currentlyViewedYear + 1
					: currentlyViewedYear;
			setCurrentlyViewedYear(nextYear);
			handleMonthClick(nextMonth);
		};

		window.addEventListener(
			'propel-filters-previous-month',
			previousMonthHandler
		);

		window.addEventListener('propel-filters-next-month', nextMonthHandler);

		return () => {
			window.removeEventListener(
				'propel-filters-next-month',
				nextMonthHandler
			);

			window.removeEventListener(
				'propel-filters-previous-month',
				previousMonthHandler
			);
		};
	});

	return (
		<div className="filter-month-picker">
			<div className="filter-month-picker__header">
				<button
					onClick={handlePrevYear}
					className="filter-month-picker__nav-button"
					aria-label={__('Previous year', 'propel')}
					disabled={prevYearDisabled}
				>
					<span className="icon icon-chev-left"></span>
				</button>

				<span className="filter-month-picker__year">
					{currentlyViewedYear}
				</span>

				<button
					onClick={handleNextYear}
					className="filter-month-picker__nav-button"
					aria-label={__('Next year', 'propel')}
				>
					<span className="icon icon-chev-right"></span>
				</button>
			</div>

			<div className="filter-month-picker__months">
				{months.map((month, index) => {
					const isActive =
						selectedYear === currentlyViewedYear &&
						selectedMonth === index;
					const isDisabled =
						currentlyViewedYear <= currentYear &&
						index + 1 < currentMonth;

					return (
						<button
							key={month}
							onClick={() => handleMonthClick(index)}
							className={`filter-month-picker__button ${
								isActive
									? 'filter-month-picker__button--active'
									: ''
							}`}
							disabled={isDisabled}
						>
							{month}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default MonthPicker;
